export const isNodeServer = () => typeof window === "undefined";

// runtime.ts
export const IS_BROWSER = typeof window !== "undefined";
export const IS_NODE = typeof process !== "undefined" && !!(process as any).release?.name;

export function getEnvVar(key: string): string | undefined {
  if (IS_NODE) {
    // Node（サーバ）だけ参照
    return (process as any).env?.[key];
  }
  // ブラウザでは参照しない（必要なら public 環境変数へ）
  return undefined;
}

export const isValidKey = <T extends object>(
  key: string | number | symbol,
  obj: T
): key is keyof typeof obj => {
  return key in obj;
};

export const generateUniqueKeySeparator = "::";
export const generateUniqueKey = (
  label = "id",
  seperator = generateUniqueKeySeparator
) => {
  return (
    label +
    seperator +
    Date.now().toString(36) +
    Math.random().toString(36).substr(2, 5)
  );
};
